import { useState } from "react";
import { ShieldAlert, X } from "lucide-react";
import { RIGHTS } from "@/data/legalData";
import {
  Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription, SheetTrigger,
} from "@/components/ui/sheet";

export const EmergencyRightsBar = () => {
  const [open, setOpen] = useState(false);
  const core = RIGHTS.slice(0, 4);
  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <button
          data-testid="emergency-rights-fab"
          className="fixed bottom-6 right-6 z-50 flex items-center gap-2 rounded-full bg-terracotta hover:bg-terracotta-hover text-white pl-4 pr-5 py-3 shadow-lg shadow-terracotta/30 transition-transform hover:-translate-y-0.5"
        >
          <ShieldAlert className="h-5 w-5" />
          <span className="text-sm font-semibold">Know My Rights</span>
        </button>
      </SheetTrigger>
      <SheetContent side="right" className="w-full sm:max-w-md bg-parchment-50 border-parchment-200 overflow-y-auto thin-scroll">
        <SheetHeader className="text-left">
          <span className="font-mono text-xs uppercase tracking-[0.18em] text-terracotta">Stopped by police?</span>
          <SheetTitle className="font-serif text-3xl text-forest-900">Your 4 core rights, right now</SheetTitle>
          <SheetDescription className="text-ink-500">
            Stay calm. You can invoke these at any time. General information only.
          </SheetDescription>
        </SheetHeader>
        <div className="mt-6 space-y-4">
          {core.map((r, i) => (
            <div key={r.title} data-testid={`emergency-right-${i}`} className="rounded-2xl border border-parchment-200 bg-white p-5">
              <div className="flex items-center justify-between mb-1.5">
                <h3 className="font-semibold text-forest-900">{r.title}</h3>
                <span className="font-mono text-[10px] uppercase tracking-wider text-forest-600 bg-forest-100 px-2 py-0.5 rounded-full">{r.statute}</span>
              </div>
              <p className="text-sm text-ink-700 leading-relaxed">{r.body}</p>
            </div>
          ))}
          <div className="rounded-2xl border-l-4 border-terracotta bg-terracotta-subtle p-5">
            <p className="text-sm text-[#8C3415] leading-relaxed">
              Say clearly: <strong>"I am invoking my right to remain silent, and I want a lawyer."</strong> Then stop talking.
            </p>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
};
